import React from 'react'
import classNames from 'classnames'
import s from './ModeItem.less'
import SVGIcon from '../svg/SVGIcon'

const ModeItem = ({ label = '', selected = false, icon, description, onClick, displayHighlightBar = true }) => {
  return (
    <div
      className={classNames(s.root, selected && s.selected, displayHighlightBar ? s.content : s.contentFavourite)}
      onClick={onClick}
      title={label}
    >
      <span className={classNames('icon', s.icon)}>
        <SVGIcon icon={icon} />
      </span>
      <span className={s.label}>{description}</span>
      {displayHighlightBar && <div className={classNames(s.bar, selected && s.highlightedBar)}></div>}
    </div>
  )
}

export default ModeItem
